import React, { useState, useEffect } from 'react';
import { IProgressBarProps } from './types';
import { LESSON_PROGRESS_UPDATE_EVENT_NAME } from '../LessonProgressProvider/LessonProgressProvider';

export const ProgressBar = ({ data }) => {
  const [percentage, setPercentage] = useState(data?.percentage ?? 0);
  const style = {
    width: `${percentage}%`,
  };

  useEffect(() => {
    pubsub.subscribe(LESSON_PROGRESS_UPDATE_EVENT_NAME, setPercentage);
    return () =>
      pubsub.unsubscribe(LESSON_PROGRESS_UPDATE_EVENT_NAME, setPercentage);
  }, []);

  return (
    <>
      <div className="Progress">
        <div
          className="Progress-bar"
          style={style}
          data-testid="progress-bar"
        />
      </div>
    </>
  );
};

ProgressBar.propTypes = IProgressBarProps;

export default ProgressBar;
